import { Injectable } from '@angular/core';
import { api } from '../api';
import { Storage } from '../constants';

@Injectable()
export class BrandingService {
    hexDigits = new Array('0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f');

    constructor() {
    }

    public getLogoUrl() {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.BRANDING_LOGO;
        return themeUrl;
    }

    public setTheme() {
        this.setBrandingStyles();
        this.setBrandingBackgroundImage();
    }


    public setBrandingBackgroundImage() {
        const backgroundImageUrl = this.getCareerBgImgUrl();
        if (document.getElementById('idBackdrop')) {
            document.getElementById('idBackdrop').style.backgroundImage = 'url(' + backgroundImageUrl + ')';
        }
    }

    public setPWATheme() {
        this.setPWABrandingStyles();
        this.setPWABrandingBackgroundImage();
        this.setPWABrandingLogo();
    }

    public rgb2hex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return '#' + this.hex(rgb[1]) + this.hex(rgb[2]) + this.hex(rgb[3]);
    }

    public hex(x) {
        return isNaN(x) ? '00' : this.hexDigits[(x - x % 16) / 16] + this.hexDigits[x % 16];
    }

    public getDonutThemeColors() {
        const response = [
            { max: 0, name: '', color: '#eeeeee' },
            { max: 25, name: 'donut-danger', color: '' },
            { max: 50, name: 'donut-warning', color: '' },
            { max: 75, name: 'donut-info', color: '' },
            { max: 100, name: 'donut-success', color: '' }
        ];
        const defaults = [
            { max: 0, name: '', color: '#eeeeee' },
            { max: 25, name: 'donut-danger', color: '#f27c2a' },
            { max: 50, name: 'donut-warning', color: '#ffc600' },
            { max: 75, name: 'donut-info', color: '#227AB9' },
            { max: 100, name: 'donut-success', color: '#1fbba6' }
        ];
        const empty = [];
        response.forEach(e => {
            const ele = document.getElementsByClassName(e.name)[0] as HTMLElement;
            if (ele) {
                e.color = this.rgb2hex(getComputedStyle(ele).color);
                if (e.color === '#000000') {
                    empty.push(e.name);
                }
            }
        });
        // If no theme is set (set to default), all colors will return #000000
        return (empty.length === 4) ? defaults : response;
    }

    public setPWABrandingBackgroundImage() {
        const backgroundImageUrl = this.getMobileBgImgUrl();
        const background = document.getElementsByClassName('page-background')[0] as HTMLElement;
        if (background) {
            background.style.backgroundImage = 'url(' + backgroundImageUrl + ')';
        }
    }

    public setPWABrandingLogo() {
        const logoImageUrl = this.getMobileLogoUrl();
        const logo = document.getElementsByClassName('menu-mobile center')[0].getElementsByTagName('img')[0];
        if (logo) {
            logo.src = logoImageUrl;
        }
    }

    public getMobileBgImgUrl() {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.PWA_BACKGROUND_IMAGE;
        return themeUrl;
    }

    public getMobileLogoUrl() {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.PWA_BRANDING_LOGO;
        return themeUrl;
    }

    public setPWABrandingStyles() {
        const link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.type = 'text/css';
        link.href = this.getPWAThemeUrl();
        document.head.appendChild(link);
    }

    private setBrandingStyles() {
        const link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.type = 'text/css';
        link.href = this.getThemeUrl();
        document.head.appendChild(link);
    }

    private getPWAThemeUrl() {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.PWA_THEME_URL;
        return themeUrl;
    }

    private getCareerBgImgUrl() {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.BACKGROUNG_IMAGE;
        return themeUrl;
    }

    private getThemeUrl(): string {
        let themeUrl = window.localStorage.getItem(Storage.ELIXHRUI_URL);
        themeUrl = themeUrl + api.branding.THEME_URL;
        return themeUrl;
    }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/branding/branding.service.ts